<template>
    <div class="disclosure">
        <div class="disclosure-title">
            <div class="label">{{ disclosureText }}</div>
            <a class="icon" @click="displayDisclosurePopup"></a>
        </div>
        <div class="disclosure-outer-content" v-html="props.disclosureOuter"></div>
        <DisclosurePopup
            v-if="showDisclosurePopup"
            :disclosurePopup="props.disclosurePopup"
            @close="closeDisclosurePopup"
        />
    </div>
</template>

<script >
import DisclosurePopup from './disclosure-popup.vue';
import { _lang } from '../common/lang';
import { computed, ref } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  disclosureOuter: {
    type: String,
    default: ''
  },
  disclosurePopup: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const disclosureText = computed(() => {
    return _lang(`disclosure`);
  });
  const showDisclosurePopup = ref(false);
  /**
   * 显示披露弹窗
   */
  function displayDisclosurePopup() {
    showDisclosurePopup.value = true;
  }

  /**
   * 关闭披露弹窗
   */
  function closeDisclosurePopup() {
    showDisclosurePopup.value = false;
  }
  return {
    props,
    disclosureText,
    showDisclosurePopup,
    displayDisclosurePopup,
    closeDisclosurePopup
  };
};
__sfc_main.components = Object.assign({
  DisclosurePopup
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.disclosure {
    margin-top: 0.2rem;
    padding: 0 0.36rem;
    .disclosure-title {
        display: flex;
        align-items: center;
        .label {
            line-height: 0.28rem;
            font-size: 0.24rem;
            color: #9a9a9a;
        }
        .icon {
            display: inline-block;
            width: 0.32rem;
            height: 0.32rem;
            background: url('../images/tip-gray.svg') no-repeat center;
            background-size: 0.18rem 0.18rem;
        }
    }
    .disclosure-outer-content {
        margin-top: 0.12rem;
        font-size: 0.24rem;
        color: #9a9a9a;
        line-height: 0.29rem;
    }
}
</style>
